export enum Role {
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin'
  }